<template>
  <div>
    <div class="row no-gutters word-cloud">
      <div class="col-4 loader" v-if="loader">
        <b-spinner
          variant="primary"
          type="grow"
          :label="`${this.$t('reports.loadingLabel')}...`"
        ></b-spinner>
      </div>
      <div class="col-4" v-else>
        <template v-if="myMetric == 'nps-0-10' || myMetric == 'nps-1-5'">
          <p>
            <span style="background-color: #4ce595;"></span>
            {{ $t('reports.promoterLabel') }}
          </p>
        </template>
        <template
          v-else-if="
            myMetric === 'ces-1-5' ||
            myMetric === 'csat-1-5' ||
            myMetric === '5-stars'
          "
          ><p>
            <span style="background-color: #4ce595;"></span>
            {{ $t('reports.noteCloudPromoter') }}
          </p></template
        >
        <template
          v-else-if="
            myMetric === 'like-dislike'
          "
          ><p>
            <span style="background-color: #4ce595;"></span>
            Like
          </p></template
        >
        <wordcloud
          :rotate="{ from: -90, to: 90, numOfOrientation: 5 }"
          data-group="promoters"
          :data="promoters"
          nameKey="name"
          valueKey="value"
          :color="promotersColors"
          :showTooltip="true"
          :wordClick="wordClickHandlerPromoters"
        ></wordcloud>
      </div>
      <div class="col-4 loader" v-if="loader">
        <b-spinner
          variant="primary"
          type="grow"
          :label="`${this.$t('reports.loadingLabel')}...`"
        ></b-spinner>
      </div>
      <div class="col-4" v-else>
        <template v-if="myMetric == 'nps-0-10' || myMetric == 'nps-1-5'">
          <p>
            <span style="background-color: #ffca27;"></span>
            {{ $t('reports.neutralLabel') }}
          </p>
        </template>
        <template
          v-else-if="
            myMetric === 'ces-1-5' ||
            myMetric === 'csat-1-5' ||
            myMetric === '5-stars'
          "
          ><p>
            <span style="background-color: #ffca27;"></span>
            {{ $t('reports.noteCloudNeutral') }}
          </p></template
        >
        <wordcloud
          :rotate="{ from: -90, to: 90, numOfOrientation: 5 }"
          data-group="neutrals"
          :data="neutrals"
          nameKey="name"
          valueKey="value"
          :color="neutralsColors"
          :showTooltip="true"
          :wordClick="wordClickHandlerNeutrals"
        ></wordcloud>
      </div>
      <div class="col-4 loader" v-if="loader">
        <b-spinner
          variant="primary"
          type="grow"
          :label="`${this.$t('reports.loadingLabel')}...`"
        ></b-spinner>
      </div>
      <div class="col-4" v-else>
        <template v-if="myMetric == 'nps-0-10' || myMetric == 'nps-1-5'">
          <p>
            <span style="background-color: #d62027;"></span>
            {{ $t('reports.detractorLabel') }}
          </p>
        </template>
        <template
          v-else-if="
            myMetric === 'ces-1-5' ||
            myMetric === 'csat-1-5' ||
            myMetric === '5-stars'
          "
          ><p>
            <span style="background-color: #d62027;"></span>
            {{ $t('reports.noteCloudDetractor') }}
          </p></template
        >
        <template
          v-else-if="
            myMetric === 'like-dislike'
          "
          ><p>
            <span style="background-color: #d62027;"></span>
            Dislike
          </p></template
        >
        <wordcloud
          :rotate="{ from: -90, to: 90, numOfOrientation: 5 }"
          data-group="detractors"
          :data="detractors"
          nameKey="name"
          valueKey="value"
          :color="detractorsColors"
          :showTooltip="true"
          :wordClick="wordClickHandlerDetractors"
        ></wordcloud>
      </div>
    </div>
    <div class="row no-gutters list-answers">
      <div class="col-12">
        <list-answers
          :word-selected="wordSelected"
          :action="myActionId === '0'"
          :group="group"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

import wordcloud from 'vue-wordcloud';
import listAnswers from './list-answers';
import EventBus from '../../../../eventBus';

export default {
  name: 'app',
  components: {
    wordcloud,
    listAnswers,
  },
  watch: {
    actionGroupData: function watchActionGroupData() {
      this.wordSelected = null;
      this.loader = true;
      this.setWordCloud({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        metric: this.myMetric,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.promoters = this.wordcloud.promoters;
        this.neutrals = this.wordcloud.neutrals;
        this.detractors = this.wordcloud.detractors;
        this.loader = false;
      });
    },
    myActionId: function watchMyActionId() {
      this.wordSelected = null;
      this.loader = true;
      this.setWordCloud({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.promoters = this.wordcloud.promoters;
        this.neutrals = this.wordcloud.neutrals;
        this.detractors = this.wordcloud.detractors;
        this.loader = false;
      });
    },
    myIh1: function watchMyIh1() {
      this.loader = true;
      this.setWordCloud({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.promoters = this.wordcloud.promoters;
        this.neutrals = this.wordcloud.neutrals;
        this.detractors = this.wordcloud.detractors;
        this.loader = false;
      });
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.loader = true;
      this.setWordCloud({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.promoters = this.wordcloud.promoters;
        this.neutrals = this.wordcloud.neutrals;
        this.detractors = this.wordcloud.detractors;
        this.loader = false;
      });
    },
    myIh2: function watchMyIh2() {
      this.loader = true;
      this.setWordCloud({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.promoters = this.wordcloud.promoters;
        this.neutrals = this.wordcloud.neutrals;
        this.detractors = this.wordcloud.detractors;
        this.loader = false;
      });
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.loader = true;
      this.setWordCloud({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.promoters = this.wordcloud.promoters;
        this.neutrals = this.wordcloud.neutrals;
        this.detractors = this.wordcloud.detractors;
        this.loader = false;
      });
    },
    myMetric: function watchMyMetric() {
      this.wordSelected = null;
      this.loader = true;
      this.setWordCloud({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.promoters = this.wordcloud.promoters;
        this.neutrals = this.wordcloud.neutrals;
        this.detractors = this.wordcloud.detractors;
        this.loader = false;
      });
    },
    calendarDates: async function watchDates() {
      this.wordSelected = null;
      this.loader = true;
      this.setWordCloud({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.promoters = this.wordcloud.promoters;
        this.neutrals = this.wordcloud.neutrals;
        this.detractors = this.wordcloud.detractors;
        this.loader = false;
      });
    },

    'indicatorData.value': async function watchIndicatorData() {
      this.wordSelected = null;
      this.loader = true;
      this.setWordCloud({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.promoters = this.wordcloud.promoters;
        this.neutrals = this.wordcloud.neutrals;
        this.detractors = this.wordcloud.detractors;
        this.loader = false;
      });
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      this.wordSelected = null;
      this.loader = true;
      this.setWordCloud({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        metric: this.myMetric,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.promoters = this.wordcloud.promoters;
        this.neutrals = this.wordcloud.neutrals;
        this.detractors = this.wordcloud.detractors;
        this.loader = false;
      });
    },
  },
  data: () => ({
    group: null,
    promotersColors: ['#4ce595', '#5ff5a7', '#71f0ae', '#8af2bc'],
    neutralsColors: ['#ffca27', '#fad04d', '#fcdb72', '#fce59a'],
    detractorsColors: ['#d62027', '#db3b41', '#db565b', '#f59599'],
    wordSelected: null,
    promoters: [],
    neutrals: [],
    detractors: [],
    loader: false,
  }),
  computed: {
    ...mapState('charts', ['wordcloud']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('companies', ['myMetric']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },
  methods: {
    ...mapActions('charts', ['setWordCloud']),

    wordClickHandlerPromoters(name, value, vm) {
      this.group = vm.$el.getAttribute('data-group');
      this.wordSelected = name;
    },
    wordClickHandlerNeutrals(name, value, vm) {
      this.group = vm.$el.getAttribute('data-group');
      this.wordSelected = name;
    },
    wordClickHandlerDetractors(name, value, vm) {
      this.group = vm.$el.getAttribute('data-group');
      this.wordSelected = name;
    },
  },
  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
  mounted() {
    this.loader = true;
    this.setWordCloud({
      companyId: this.userAuth.companyId,
      token: this.userAuth.token,
      actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
      ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
      ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
      groupId: this.actionGroupData._id,
      startDate: this.calendarDates.start ? this.calendarDates.start : null,
      endDate: this.calendarDates.end ? this.calendarDates.end : null,
      metric: this.myMetric,
      indicator: this.indicatorName,
      indicatorValue: this.indicatorData.value,
      indicatorRange: this.indicatorData.range,
    }).then(() => {
      this.promoters = this.wordcloud.promoters;
      this.neutrals = this.wordcloud.neutrals;
      this.detractors = this.wordcloud.detractors;

      this.loader = false;
    });

    EventBus.$on('drawer', () => {
      this.loader = true;
      this.setWordCloud({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        metric: this.myMetric,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.promoters = this.wordcloud.promoters;
        this.neutrals = this.wordcloud.neutrals;
        this.detractors = this.wordcloud.detractors;
        this.loader = false;
      });
    });
  },
};
</script>

<style lang="scss">
@import '@/themes/default/variables.scss';

.word-cloud {
  .col-4 {
    p {
      font-size: 1.2em;
      font-weight: 100;
      color: $title-color;
      position: relative;
      padding-left: 15px;
      margin-left: 16px;
      text-transform: uppercase;
      span {
        position: absolute;
        width: 4px;
        height: 25px;
        left: 0;
        top: 3px;
      }
    }
  }
}

.tooltip {
  min-width: 250px !important;
  max-width: 500px !important;
  min-height: 100px !important;
}

.list-answers {
  min-height: 280px;
}

.loader {
  width: 100%;
  height: 350px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/word-cloud/index.vue